import ResponsibleGamingPage from '@/components/shared/ResponsibleGamingPage';
import MarketingLayout from '@/components/shared/MarketingLayout';

export default function ResponsibleGaming() {
  return (
    <MarketingLayout>
      <ResponsibleGamingPage />
    </MarketingLayout>
  );
}
